import { IconButton, IconButtonProps } from '@chakra-ui/react';
import React from 'react';
import { ReactComponent as ContextVertIcon } from 'resources/images/context-vertical.svg';

export const ContextMenuButton = (props: Partial<IconButtonProps>) => {
  return (
    <IconButton
      className="options"
      aria-label="more"
      aria-controls="long-menu"
      aria-haspopup="true"
      data-testid="kebab-menu-button"
      size="large"
      variant="ghost"
      _hover={{
        bg: 'transparent',
      }}
      sx={{ path: { fill: 'iconBase' } }}
      ml={2}
      border="none"
      {...props}
    >
      <ContextVertIcon />
    </IconButton>
  );
};
